import React, { useEffect, useRef } from "react";
import "./NewsDetailPopup.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectFade } from "swiper/modules";

// Импорт стилей Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

function NewsDetailPopup({ isOpen, onClose, news }) {
  const swiperRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;

      switch (e.key) {
        case "Escape":
          onClose();
          break;
        case "ArrowLeft":
          swiperRef.current?.swiper?.slidePrev();
          break;
        case "ArrowRight":
          swiperRef.current?.swiper?.slideNext();
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !news) return null;

  const imageUrls = news.image_urls || [];

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="news-detail-popup" onClick={(e) => e.stopPropagation()}>
        <button className="news-detail-popup__close" onClick={onClose}>
          ×
        </button>

        {imageUrls.length > 0 && (
          <div className="news-detail-popup__slider">
            <Swiper
              ref={swiperRef}
              modules={[Navigation, Pagination, EffectFade]}
              spaceBetween={30}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              loop={imageUrls.length > 1}
              effect="fade"
              fadeEffect={{
                crossFade: true,
              }}
            >
              {imageUrls.map((imageUrl, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={imageUrl}
                    alt={`${news.title} - изображение ${index + 1}`}
                    className="news-detail-popup__image"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}

        <div className="news-detail-popup__content">
          <h2 className="news-detail-popup__title">{news.title}</h2>
          <p className="news-detail-popup__text">{news.content}</p>
        </div>
      </div>
    </div>
  );
}

export default NewsDetailPopup;
